<div class="At-SettingsContent">
  <div class="At-SubcriptionContent">
    <div class="At-Titel">
      <h2>VIP Subscription</h2>
    </div>
    <div class="At-Subcriptionbox">
      <h3><sup>$</sup>200<sub>/ month</sub></h3>
      <div class="At-Titel">
        <h4>VIP SUBSCRIPTION INCLUDES:</h4>
      </div>
      <ul>
        <li><i class="icon-tick"></i>Create Channels</li>
        <li><i class="icon-tick"></i>Do Broadcasting</li>
        <li><i class="icon-tick"></i>Add Job Title</li>
        <li><i class="icon-tick"></i>And many more features </li>
      </ul>
      <div class="At-Description">
        <p>7 days free trial, then $200/month </p>
      </div>
      <a href="javascript:void(0);" class="At-Btn">START SUBSCRIPTION</a>
    </div>
    <div class="At-Note">
      <p>Plan automatically renews until cancel</p>
    </div>
  </div>
</div>
